import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import {TranslateService} from '@ngx-translate/core';
import {ApiService} from '../../services/api.service';
import {MenuController, ModalController} from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {

  @Input() title = '';
  @Input() showBackButton = false;
  @Input() showMenu = false;
  @Input() backButtonUrl = '';

  constructor(
    private router: Router,
    public translateService: TranslateService,
    public storageService: StorageService,
    public apiService: ApiService,
    public menuController: MenuController,
    private modalController: ModalController
  ) { }

  goBack() {
    if (this.backButtonUrl === 'dismiss') {
      this.modalController.dismiss().then();
    } else {
      this.router.navigate([this.backButtonUrl]).then();
    }
  }

  openMenu() {
    this.menuController.open().then();
  }
}
